import React from "react";
import { Alert } from "antd";

// PLACEHOLDER COPY — pending final wording from Alexander (ClickUp 86d3vkwnc).
// This is the ONLY place the string exists; change it here and every surface updates.
export const BETA_NOTICE_MESSAGE =
	"Beta — the treatment plan workflow is currently in beta. AI-generated content is " +
	"advisory only and must be reviewed by the treating practitioner before any clinical decision.";

interface BetaNoticeProps {
	/** Tighter spacing for surfaces with limited vertical room (e.g. the inline consult view). */
	compact?: boolean;
}

// Non-dismissible beta-phase advisory for the treatment plan workflow. No `closable` prop by
// design — a dismissed warning is not a warning, and it must persist no state.
const BetaNotice: React.FC<BetaNoticeProps> = ({ compact = false }) => (
	<Alert
		type="warning"
		showIcon
		message={BETA_NOTICE_MESSAGE}
		data-testid="beta-notice"
		style={{ marginBottom: compact ? 8 : 12 }}
	/>
);

export default BetaNotice;
